import MimeType from "./MimeType";

const MimeTypes = {
	ALL: new MimeType("*/*"),
	UNKNOWN: new MimeType("application/octet-stream"),
	PDF: new MimeType("application/pdf", 1557),
	RTF: new MimeType("application/rtf", 1028),
	DOC: new MimeType("application/msword", 1082),
	DOCX: new MimeType("application/vnd.openxmlformats-officedocument.wordprocessingml.document", 1312),
	APPJSON: new MimeType("application/json", 1830),
	APPXML: new MimeType("application/xml"),
	APPXSLTXML: new MimeType("application/xslt+xml", 901),
	XFDF: new MimeType("application/vnd.adobe.xfdf"),
	XDP: new MimeType("application/vnd.adobe.xdp+xml"),
	MSG: new MimeType("application/vnd.ms-outlook", 1143),
	POSTSCRIPT: new MimeType("application/postscript", 1504),
	ACAD: new MimeType("application/acad", 1552),

	// certificate Types
	JKS: new MimeType("application/x-java-keystore"),
	PEM: new MimeType("application/x-x509-ca-cert"),
	P12: new MimeType("application/pkcs12"),
	PFX: new MimeType("application/pkcs12"),

	// Powerpoint Formats
	PPT: new MimeType("application/vnd.ms-powerpoint", 1538),
	ODP: new MimeType("application/vnd.oasis.opendocument.presentation"),
	PPTX: new MimeType("application/vnd.openxmlformats-officedocument.presentationml.presentation", 2203),

	// Text Formats
	TEXT: new MimeType("text/*"),
	PLAIN: new MimeType("text/plain", 4003),
	XML: new MimeType("text/xml", 1150),
	JSON: new MimeType("text/json"),
	HTML: new MimeType("text/html", 1101),
	CSS: new MimeType("text/css", 1142),

	// Mail Formats
	MAIL: new MimeType("mail/*"),
	MIME: new MimeType("message/rfc822", 1187),
	MHTML: new MimeType("application/x-mimearchive", 1198),

	// Archive Formats
	ZIP: new MimeType("application/zip", 1802),
	XZIP: new MimeType("application/x-zip-compressed"),
	X7ZIP: new MimeType("application/x-7z-compressed", 1826),
	TAR: new MimeType("application/x-tar", 1807),
	GZIP: new MimeType("application/gzip", 1815),
	RAR: new MimeType("application/x-rar-compressed"),

	// Image Formats
	IMAGE: new MimeType("image/*"),
	GIF: new MimeType("image/gif", 1503),
	PNG: new MimeType("image/png", 1574),
	JPEG: new MimeType("image/jpeg", 1599),
	JP2: new MimeType("image/jp2", 1646),
	TIFF: new MimeType("image/tiff", 1501),
	BMP: new MimeType("image/bmp", 1514),
	TARGA: new MimeType("image/targa", 1512),
	SVG: new MimeType("image/svg+xml", 2233),
	EMF: new MimeType("image/emf", 1564),
	WMF: new MimeType("image/wmf", 5000),
	XPNG: new MimeType("image/x-png"),
	XBMP: new MimeType("image/x-win-bitmap", 1516),
	ICO: new MimeType("image/x-icon", 1515),
	XPORTABLE: new MimeType("image/x-portable-anymap", 1588),
	XPCX: new MimeType("image/x-pcx", 1502),
	WEBP: new MimeType("image/webp", 2272),
	HEIF: new MimeType("image/heif"),
	HEIC: new MimeType("image/heic", 1729),
	HEIF_SEQUENCE: new MimeType("image/heif-sequence"),
	HEIC_SEQUENCE: new MimeType("image/heic-sequence"),

	VCARD: new MimeType("text/x-vcard", 1141),
	VCAL: new MimeType("text/calendar", 1196),

	fromString: (value: string): MimeType => {
		let retValue: MimeType = new MimeType(value);

		for (let mimeType of Object.values(MimeTypes)) {
			if (typeof mimeType === "function") {
				continue;
			}

			if (mimeType.type === retValue.type && mimeType.subtype === retValue.subtype) {
				return mimeType;
			}
		}

		return retValue;
	},

	fromId: (value: number): MimeType => {
		let retValue: MimeType = MimeTypes.UNKNOWN;

		if (value === 0) {
			return retValue;
		}

		for (let mimeType of Object.values(MimeTypes)) {
			if (typeof mimeType === "function") {
				continue;
			}

			if (mimeType.fileTypeId === value) {
				return mimeType;
			}
		}

		return retValue;
	},
}

export default MimeTypes;